// 低值采购申请表
import { Form } from "antd";
import { ApplicationInfoFormFields } from "./ApplicationInfoFormFields";
import { UserFormFields } from "@/components/UserFormFields/UserFormFields";
import type { PurchaseRequestFormProps } from "../../type";
import { NocodeMaterialFormFields } from "./NocodeMaterialFormFields";
import { CodeMaterialFormFields } from "./CodeMaterialFormFields";
import { SourcingResultFormFields } from "./SourcingResultFormFields";
import { useExistFlowHistory } from "@/hooks/services/useFlow";
import { usePurchaseRequestDetail } from "../../hooks/usePurchaseRequest";
import { useModal } from "@/hooks/modals/useModal";
import {
  createFixedAssetsNoNodeCodes,
  fillInPONodeCodes,
  purchasingStaffFillInNodeCodesForHighOrLow,
} from "../../constant";
import { FixedAssetInfoFormFields } from "./FixedAssetInfoFormFields";
import { OrderConfrimFormFields } from "../OrderConfrimFormFields";
import { useFormEditable } from "../../hooks/useFormEditable";

export const LowValuePurchaseRequisitionForm = ({
  form,
}: PurchaseRequestFormProps) => {
  const isCurrently = Form.useWatch("isCurrently", form);

  const { props } = useModal("PURCHASE_REQUEST");
  const { recordId } = props;

  const detail = usePurchaseRequestDetail(recordId);

  const { isMainFormDisabled } = useFormEditable();

  const shouldShowSourcingResultFormFields = useExistFlowHistory(
    purchasingStaffFillInNodeCodesForHighOrLow,
    detail?.insId,
  );

  const shouldShowOrderConfirm = useExistFlowHistory(
    fillInPONodeCodes,
    detail?.insId,
  );

  const shouldShowFixedAssetsFields = useExistFlowHistory(
    createFixedAssetsNoNodeCodes,
    detail?.insId,
  );

  return (
    <Form layout="vertical" disabled={isMainFormDisabled} form={form}>
      <UserFormFields />
      {/* 申请信息 */}
      <ApplicationInfoFormFields />
      {/* 申请采购物品明细 */}
      {isCurrently === 1 ? (
        <CodeMaterialFormFields />
      ) : (
        <NocodeMaterialFormFields />
      )}

      {/* 寻源结果 */}
      {shouldShowSourcingResultFormFields && <SourcingResultFormFields />}

      {/* 固定资产信息 */}
      {shouldShowFixedAssetsFields && <FixedAssetInfoFormFields />}

      {/* 订单确认 */}
      {shouldShowOrderConfirm && <OrderConfrimFormFields />}
    </Form>
  );
};
